import { useSelector } from 'react-redux';

export const useVariation = (variation): any => {
  return useSelector((s: any) => (s?.tests || []).includes(variation));
};

export default useVariation;
